import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  LogoutOutlined,
  MenuOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Authentication from "../components/authentication";
import {
  CLEAR_AUTHENTICATION_DATA,
  CLEAR_MOBILE_DETAILS,
  CLEAR_USER_DETAILS,
  FETCH_COUNTRIES,
  FETCH_CURRENT_COUNTRY,
  FETCH_DOMAIN_DETAILS,
  FETCH_PROFILE,
  INITIATE_AUTH_DRAWER,
  SESSION_EXPIRED_RESET,
  STOP_AUTH_DRAWER,
} from "../actions/types";
import { AppLocalStorage, AppSessionStorage } from "../services/contracts";
import { Badge, message, Modal } from "antd";
import {
  calculateCompletedStepsInUserProfile,
  calculateTotalStepsToCompleteProfile,
  isAuthenticated,
  redirectToOmnicuris,
  reloadPage,
  verifyIfUserCountryCodeIsPresent,
} from "../utilities";
import Hamburger from "./Hamburger";
import ElasticSearch from "./ElasticSearch";
import UserIcon from "../assets/images/user.png";
import { Helmet } from "react-helmet";
import faviconOC from "../assets/images/faviconOC.ico";
import Img from "./common/Img";
import {
  DefaultProfileIcon,
  HelpIcon,
  LogoBig,
  LogoutIcon,
} from "../utilities/resources";
import {
  EMAIL_VERIFICATION_STEP,
  MCI_UPLOAD_STEP,
  STEPS_IN_PROFILE_COMPLETION,
} from "../utilities/appStatics";
import NeedHelpModal from "./NeedHelpModal";

function Header({ showHeader }) {
  const { loggedOut, authDrawerInitiated } = useSelector(
    (state) => state.authentications
  );
  const { userDetails, failedUsers, editStatus } = useSelector(
    (state) => state.profile
  );
  const { domainDetails } = useSelector((state) => state.listings);
  const [showSearchBar, setShowSearchBar] = useState(true);
  const { currentCountry } = useSelector((state) => state.utilities);
  const [openAuth, setOpenAuth] = useState(false);
  const [openHamburger, setOpenHamburger] = useState(false);
  const [dropdownContent, setDropdownContent] = useState({
    show: false,
    content: "",
  });
  const [visibleNeedHelpPopup, showNeedHelpPopup] = useState(false);
  const [notificationRead, setNotificationRead] = useState(true);

  const totalStepsCheck =
    calculateTotalStepsToCompleteProfile(userDetails).length;
  const completedSteps =
    calculateCompletedStepsInUserProfile(userDetails).length;

  const userRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (
      window.location.href.includes("/live/") ||
      window.location.href.includes("/stream/")
    ) {
      setShowSearchBar(false);
    } else {
      setShowSearchBar(true);
    }
    let subdomain = window.location.host
      .split(".")[0]
      .replace("stg", "")
      .replace("preprod", "")
      .trim();
    subdomain =
      subdomain === "live" || subdomain.includes("localhost")
        ? "diabetesheartconnect"
        : subdomain; // Added localhost for development
    if (subdomain) {
      dispatch({
        type: FETCH_DOMAIN_DETAILS,
        payload: subdomain,
      });
    }
    dispatch({
      type: FETCH_CURRENT_COUNTRY,
    });
    fetchCountries();
  }, [window.location.href]);

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch({
        type: FETCH_PROFILE,
      });
    }
  }, [isAuthenticated()]);

  const fetchCountries = () => {
    dispatch({
      type: FETCH_COUNTRIES,
    });
  };

  useEffect(() => {
    if (loggedOut.responseCode === 200) {
      AppLocalStorage.deleteAll();
      message.success("You have been logged out successfully!");
      dispatch({ type: CLEAR_USER_DETAILS });
      reloadPage();
    }
  }, [loggedOut]);

  useEffect(() => {
    if (failedUsers !== "" && editStatus !== "failed") {
      Modal.info({
        title: "Your session has expired. Please login again",
        okText: "OK",
        onOk() {
          AppLocalStorage.deleteAll();
          dispatch({ type: SESSION_EXPIRED_RESET });
          dispatch({ type: INITIATE_AUTH_DRAWER });
        },
      });
    }
  }, [failedUsers]);

  const handleOnClickOnly = (ev) => {
    ev.stopPropagation();
    if (!isAuthenticated()) {
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      });
    } else {
      // redirectToOmnicuris(`/organization/${domainDetails.id}`, false)
    }
  };

  const handleOpenAuth = () => {
    setOpenAuth(true);
    setOpenHamburger(false);
  };

  const closeAuth = () => {
    setOpenAuth(false);
    dispatch({
      type: STOP_AUTH_DRAWER,
    });
    dispatch({
      type: CLEAR_AUTHENTICATION_DATA,
    });
    dispatch({
      type: CLEAR_MOBILE_DETAILS,
      payload: { country: currentCountry },
    });
  };

  const logout = () => {
    dispatch({ type: STOP_AUTH_DRAWER });
    dispatch({ type: CLEAR_USER_DETAILS });
    dispatch({
      type: CLEAR_MOBILE_DETAILS,
      payload: { country: currentCountry },
    });
    AppLocalStorage.deleteAll();
    AppSessionStorage.deleteAll();
    message.success("You have been logged out successfully!");
    reloadPage();
    setOpenAuth(false);
  };

  const hideDropdown = () => {
    setDropdownContent({
      ...dropdownContent,
      show: false,
      content: null,
    });
  };

  const showNeedHelp = () => {
    showNeedHelpPopup(true);
    hideDropdown();
  };

  const showFeedback = () => {
    hideDropdown();
  };

  const clickedOutside = (ev) => {
    if (userRef.current && !userRef.current.contains(ev.target)) {
      setDropdownContent({
        ...dropdownContent,
        show: false,
        content: null,
      });
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", clickedOutside);
    return () => {
      document.removeEventListener("mousedown", clickedOutside);
    };
  }, []);

  const toggleDropdown = (dropdown) => {
    setNotificationRead(false);
    setDropdownContent({
      ...dropdownContent,
      show: !dropdownContent.show,
      content: profileContent,
    });
  };

  const returnDropdownOption = (icon, header, subHead, action, route) => {
    return (
      <div
        className="profile_section"
        onClick={() => (route ? history.push(action) : action())}
      >
        <img className="dropdown_icon" src={icon} alt="user" />
        <div className="gridColumn">
          <span className="sub_options">{header}</span>
          {subHead !== "" ? (
            <span className="sub_options_desc">{subHead}</span>
          ) : null}
        </div>
      </div>
    );
  };

  const profilePendingStepsInfo = (
    <div
      className={`profileInfoBadge ${
        notificationRead && totalStepsCheck - completedSteps !== 0
          ? "pulse"
          : ""
      }`}
      onClick={() => toggleDropdown("notifications")}
    >
      <Badge
        className="badgeStyle"
        count={
          totalStepsCheck - completedSteps !== 0
            ? totalStepsCheck - completedSteps
            : null
        }
      />
    </div>
  );

  const profileCompletionInfo = userDetails.users && (
    <Fragment>
      {STEPS_IN_PROFILE_COMPLETION.map((step) => {
        if (
          step.name === MCI_UPLOAD_STEP &&
          verifyIfUserCountryCodeIsPresent(userDetails) &&
          step.forUserCountries.indexOf(userDetails.users.userCountry.code) >= 0
        ) {
          if (userDetails.users.registrationStatus === "1") {
            return (
              <span key={step.name} className="name_sub dangerText">
                MCI Under verification
              </span>
            );
          }
          if (
            userDetails.users.registrationStatus === "0" ||
            userDetails.users.registrationStatus === "3"
          ) {
            return (
              <span key={step.name} className="name_sub dangerText">
                {userDetails.users.registrationStatus === "3" ? "Re-" : null}
                Upload medical registration certificate
              </span>
            );
          }
        } else if (
          step.name === EMAIL_VERIFICATION_STEP &&
          !userDetails.users.isEmailVerified
        ) {
          return (
            <span key={step.name} className="name_sub dangerText">
              Verify email address
            </span>
          );
        }
      })}
    </Fragment>
  );

  const profileContent = (
    <div ref={userRef} className="user_section">
      {userDetails.users && (
        <div
          className="profile_section"
          onClick={() => {
            hideDropdown();
            history.push("/profile");
          }}
        >
          <div className="avatarBig">
            <Img
              src={userDetails.users.profilePic}
              defaultSrc={DefaultProfileIcon}
              width="50px"
              alt="user"
            />
          </div>
          <div className="gridColumn">
            <span className="name_big">{`${userDetails.users.title} ${userDetails.users.firstName} ${userDetails.users.lastName}`}</span>
            <div
              onClick={() => history.push("/profile")}
              className="viewProfileLink"
            >
              View Profile
            </div>
            {profileCompletionInfo}
          </div>
        </div>
      )}
      <div className="horizontal_divider" />
      {returnDropdownOption(
        HelpIcon,
        "Help & Support",
        "Reach out to us",
        showNeedHelp
      )}
      <div className="horizontal_divider" />
      {returnDropdownOption(LogoutIcon, "Logout", "", logout)}
    </div>
  );
  return (
    <header hidden={!showHeader} id="header">
      <Helmet>
        <title>
          {domainDetails.orgType === "certifier" ? "Omnicuris" : "Doc Pro"}
        </title>
        {domainDetails.orgType === "certifier" && (
          <link
            rel="icon"
            type="image/png"
            href={faviconOC}
            sizes="64x64 32x32 24x24 16x16"
          />
        )}
      </Helmet>
      <div className="headerTopRow">
        {domainDetails &&
        domainDetails.orgType === "industry_partner" &&
        isAuthenticated === null ? (
          <button onClick={handleOpenAuth} className="userIcon">
            <img src={UserIcon} alt="user" />
          </button>
        ) : (
          <button
            onClick={() => setOpenHamburger(true)}
            className="hamburgerButton"
          >
            <MenuOutlined />
          </button>
        )}
        <section id="headerLeftSection">
          <div id="logo" onClick={() => history.push("/")}>
            {domainDetails && domainDetails.name && (
              <Fragment>
                <img src={domainDetails.image} alt={domainDetails.name} />
                <h1 id="organizationName">{domainDetails.name}</h1>
              </Fragment>
            )}
          </div>
        </section>
        <section id="headerRightSection">
          {showSearchBar && <ElasticSearch />}
          <button
            id="users"
            onClick={() => (isAuthenticated() ? null : handleOpenAuth())}
          >
            {isAuthenticated() ? (
              <div className="users_container">
                {userDetails.users && (
                  <Fragment>
                    <span
                      className="usersDp"
                      onClick={() => history.push("/profile")}
                    >
                      <Img
                        src={userDetails.users.profilePic}
                        defaultSrc={DefaultProfileIcon}
                        alt="user"
                      />
                    </span>
                    <span
                      className="usersName"
                      onClick={() => history.push("/profile")}
                    >{`${userDetails.users.title} ${userDetails.users.firstName}`}</span>
                    <div
                      className={
                        notificationRead &&
                        totalStepsCheck - completedSteps !== 0
                          ? "pulse"
                          : ""
                      }
                      onClick={() => toggleDropdown("notifications")}
                    >
                      <Badge
                        className="badgeStyle"
                        count={
                          totalStepsCheck - completedSteps !== 0
                            ? totalStepsCheck - completedSteps
                            : null
                        }
                      >
                        <CaretDownOutlined
                          onClick={() => toggleDropdown("profile")}
                          className="right_icons"
                        />
                      </Badge>
                    </div>
                    <div className="usersMenu">
                      <ul>
                        <li onClick={logout}>
                          <LogoutOutlined />
                          Logout
                        </li>
                      </ul>
                    </div>
                  </Fragment>
                )}
                {dropdownContent.show ? dropdownContent.content : null}
              </div>
            ) : !isAuthenticated() &&
              history.location.pathname.includes("/live/") ? null : (
              <span>
                Login / Sign Up
                <RightOutlined style={{ marginLeft: 10 }} />
              </span>
            )}
          </button>
        </section>
      </div>
      <div className="headerBottomRow">
        {domainDetails && domainDetails.orgType === "certifier" && (
          <nav id="headerNav">
            <NavLink to="/" exact>
              Home
            </NavLink>
            <NavLink to="/cme">CMEs</NavLink>
            <NavLink to="/webinars">Webinars</NavLink>
            <NavLink to="" style={{ marginLeft: "auto" }}>
              <div className="oc-logo">
                <h4 id="oc-h4">POWERED BY</h4>
                <img src={LogoBig} className="section_right_logo" alt="logo" />
              </div>
            </NavLink>
          </nav>
        )}
      </div>
      <Authentication
        isVisible={openAuth || authDrawerInitiated}
        closeAuth={closeAuth}
      />
      <Hamburger
        openHamburger={openHamburger}
        closeHamburger={setOpenHamburger}
        logout={logout}
        login={handleOpenAuth}
        profilePendingStepsInfo={profilePendingStepsInfo}
        profileCompletionInfo={profileCompletionInfo}
        showNeedHelpPopup={showNeedHelpPopup}
      />
      <NeedHelpModal
        visible={visibleNeedHelpPopup}
        setVisible={showNeedHelpPopup}
      />
    </header>
  );
}

export default Header;
